import React, { Component } from 'react';
import { LuBadgeInfo, LuEye, LuFileEdit, LuTrash2, LuEyeOff } from 'react-icons/lu';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { DeleteDepartmentRes, DeleteDepartmentTodo } from 'redux/slice/super-admin/master/department/DeleteDepartment';
import { AdminDeleteDepartmentRes, AdminDeleteDepartmentTodo } from 'redux/slice/admin/master/department/AdminDeleteDepartment';

class AdminDepartmentAction extends Component {
    constructor(props) {
        super(props);
        this.edit_department = this.edit_department?.bind(this);
        this.del_department = this.del_department?.bind(this);
        this.del_res = this.del_res?.bind(this);
    }



    edit_department() {
        this.props.history.push('../admin/update-department', { state: this.props.data });
        // const { navigate, data } = this.props;
        // navigate('../superadmin/update-department', { state: data });
        // console.log(this.props.data)
    }

    del_department() {
        const { dispatch, data } = this.props;
        Swal.fire({
            title: "Department Delete",
            text: "Are You Sure Want To Delete This Department?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Delete'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(AdminDeleteDepartmentTodo(data.id)).then(() => this.del_res());
            }
        });
    }

    del_res() {
        const { bool, setBool } = this.props;
        if (AdminDeleteDepartmentRes && AdminDeleteDepartmentRes.success) {
            setBool(!bool); 
            Swal.fire(
                "Department",
                'Department Deleted Successfully',
                'success'
            );
        } else {
            toast.error(AdminDeleteDepartmentRes && AdminDeleteDepartmentRes.message, { position: "bottom-right" });
        }
    }

    render() {
        return (
            <div>
                <LuFileEdit size={20} className='edit text-success ms-3'
                    onClick={this.edit_department}
                    data-tooltip-id='edit'
                    data-tooltip-content="Edit Department!"
                    data-tooltip-place="bottom"
                />

                <LuTrash2 size={20} className='delete text-danger ms-3'
                    onClick={this.del_department}
                    data-tooltip-id='del'
                    data-tooltip-content="Delete Department!"
                    data-tooltip-place="bottom"
                />

                <Tooltip id='edit' className='bg-success tooltip_msg' />
                <Tooltip id='del' className='bg-danger tooltip_msg' />
                <Tooltip id='details' className='bg-primary tooltip_msg' />
                <Tooltip id='active' className='bg-secondary tooltip_msg' />
                <Tooltip id='deactivate' className='bg-secondary tooltip_msg' />
            </div>
        );
    }
}

export default withRouter(connect()(AdminDepartmentAction));

